module.exports = __webpack_public_path__ + "img/PAMMAccountLogo6.07ddc719.svg";